<div class="gauge-content">
    <div class="gauge">
        <span class="gauge-metric-0">0</span>
        <span class="gauge-metric-20">20</span>
        <span class="gauge-metric-40">40</span>
        <span class="gauge-metric-60">60</span>
        <span class="gauge-metric-80">80</span>
        <span class="gauge-metric-100">100</span>
        <div class="gauge-body">
            <div class="gauge-fill"></div>
            <div class="gauge-cover">
                <div class="gauge-value">
                    <span>{{this.value}}%</span>
                </div>
            </div>
        </div>
    </div>
</div>